import { useIntl } from 'react-intl';
import { HealthcareProviderDto } from 'common/api';
import { CheckCircleIcon } from '@clariness/clarikit-icons';
import { Box, Icon, Text } from '@clariness/clarikit-react';

type Props = {
  healthcareProvider?: HealthcareProviderDto | null;
};

export const HealthcareProviderDetails = ({ healthcareProvider }: Props) => {
  const intl = useIntl();

  if (!healthcareProvider) {
    return null;
  }

  const rows = [
    {
      id: 'first-name',
      label: intl.formatMessage({
        id: 'is.patient_details_modal.hcp_details.first_name',
        defaultMessage: 'First Name',
      }),
      value: healthcareProvider.firstName,
    },
    {
      id: 'last-name',
      label: intl.formatMessage({
        id: 'is.patient_details_modal.hcp_details.last_name',
        defaultMessage: 'Last Name',
      }),
      value: healthcareProvider.lastName,
    },
    {
      id: 'phone-number',
      label: intl.formatMessage({
        id: 'is.patient_details_modal.hcp_details.phone_number',
        defaultMessage: 'Phone Number',
      }),
      value: healthcareProvider.phoneNumber,
    },
    {
      id: 'email',
      label: intl.formatMessage({
        id: 'is.patient_details_modal.hcp_details.email',
        defaultMessage: 'E-mail',
      }),
      value: healthcareProvider.email,
    },
    {
      id: 'medical-site',
      label: intl.formatMessage({
        id: 'is.patient_details_modal.hcp_details.medical_site',
        defaultMessage: 'Medical Site',
      }),
      value: healthcareProvider.medicalSite,
    },
  ];

  return (
    <Box
      display="flex"
      flexDirection="column"
      gap="8"
      width="100%"
      style={{ marginTop: '40px' }}
    >
      <Text as="h6" variant="headingXs">
        {intl.formatMessage({
          id: 'is.patient_details_modal.hcp_details.title',
          defaultMessage: 'HCP Details',
        })}
      </Text>
      <Box width="100%" height="1px" backgroundColor="color-gray-variant-4" />
      <Box as="dl" display="flex" flexDirection="column" gap="16" margin="0">
        {rows.map((row) => (
          <Box
            key={row.id}
            display="flex"
            flexWrap="wrap"
            gap="40"
            width="100%"
          >
            <Box as="dt" style={{ flex: '0 0 150px' }}>
              <Text as="span" variant="bodyMd" fontWeight="bold">
                {row.label}
              </Text>
            </Box>
            <Box as="dd" margin="0" minWidth="0" style={{ flex: '1 1 12rem' }}>
              <Text as="span" variant="bodyMd">
                {row.value}
              </Text>
            </Box>
          </Box>
        ))}
      </Box>
      <Box
        display="flex"
        alignItems="center"
        gap="16"
        style={{ marginTop: '16px' }}
      >
        <Box>
          <Icon source={CheckCircleIcon} color="color-green-primary" />
        </Box>
        <Text as="p" variant="bodyMd">
          {intl.formatMessage({
            id: 'is.patient_details_modal.hcp_details.patient_allowed_contact',
            defaultMessage: 'Patient allowed contact',
          })}
        </Text>
      </Box>
    </Box>
  );
};
